import React from "react";
import "./AIRegister.css";
const AIAvatar = ({listening, speaking, processing}) => {
    const status =
        speaking
            ? "Speaking..."
            : processing
                ? "Understanding..."
                : listening
                    ? "Listening..."
                    : "Ready";
    return (
        <div className="ai-avatar-container">

            <div
                className={`avatar-reg ${
                    speaking || listening ? "pulse" : ""
                }`}
            >
                <img
                    src="/doctor.png"
                    alt="DrHiS AI"
                />
            </div>

            <h3 className="mt-3">
                DrHiS AI Assistant
            </h3>

            <div className="status">

                {speaking && "🔊 "}

                {processing && "🧠 "}

                {listening && "🎤 "}

                {status}

            </div>

        </div>
    );
};
export default AIAvatar;